import * as React from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: {
        width: "fit-content",
        background: "#EAEBEF 0% 0% no-repeat padding-box",
        borderRadius: 10,
        // marginTop: '1.5rem',
        "& .Mui-selected": {
            color: "#fff !important",
            zIndex: 1,
        },
        "& .MuiTabs-indicator": {
            height: 48,
            borderRadius: 10,
        },
        "& .MuiButtonBase-root": {
            textTransform: "none",
            minWidth: 80,
        },
    },
});

export default function ToggleSwitch({ handleChange, value, options }) {
    const classes = useStyles();
    return (
        <TabContext value={value}>
            <TabList onChange={handleChange} className={classes.root}>
                {options.map((option) => (
                    <Tab label={option.value} value={option.key} />
                ))}
            </TabList>
        </TabContext>
    );
}
